// // AddEditStudentExamResult.jsx (FULL CODE - FINAL UI)
// // ✅ Course -> Batch -> Pattern (BatchExamMaster) dropdown
// // ✅ Pattern label shows pattern_name (term_name) from backend JOIN
// // ✅ Load => Enrollment API (batch-wise) => student list
// // ✅ No SessionYear, No Search Student (optional)  (removed)
// // ✅ Table: Roll/Enroll, Student Name, Total Marks (optional), Obtained Marks (required)
// // ✅ Save => POST/PUT StudentExamResult Summary APIs (same as you had)

// import React, { useEffect, useMemo, useState } from 'react';
// import {
//   Card,
//   CardTitle,
//   CardBody,
//   Button,
//   Row,
//   FormGroup,
//   Label,
//   Input,
//   Table,
//   FormText,
// } from 'reactstrap';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import Select from 'react-select';
// import { toast } from 'react-toastify';

// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { apiService } from '../../constants/ApiService';
// import useVendorBranch from '../../utils/useVendorBranch';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';

// // ---------- helpers ----------
// const pick = (...vals) =>
//   vals.find((v) => v !== undefined && v !== null && v !== '');

// const getCaseInsensitive = (obj, key) => {
//   if (!obj || typeof obj !== 'object') return undefined;
//   const foundKey = Object.keys(obj).find(
//     (k) => k.toLowerCase() === String(key).toLowerCase(),
//   );
//   return foundKey ? obj[foundKey] : undefined;
// };

// const normalizeArray = (payload) => {
//   if (!payload) return [];
//   if (Array.isArray(payload)) return payload;

//   const directKeys = [
//     'Data',
//     'data',
//     'List',
//     'list',
//     'Result',
//     'result',
//     'Items',
//     'items',
//     'singleRecord',
//     'SingleRecord',
//   ];
//   for (const k of directKeys) {
//     const v = getCaseInsensitive(payload, k);
//     if (Array.isArray(v)) return v;
//   }

//   const nested1 = getCaseInsensitive(payload, 'data');
//   const nested2 = getCaseInsensitive(payload, 'Data');
//   if (nested1 && typeof nested1 === 'object') {
//     const a = normalizeArray(nested1);
//     if (a.length) return a;
//   }
//   if (nested2 && typeof nested2 === 'object') {
//     const a = normalizeArray(nested2);
//     if (a.length) return a;
//   }

//   return [];
// };

// // pickers
// const getClassId = (x) => Number(x?.id ?? x?.class_id ?? x?.ClassId ?? 0) || 0;
// const getClassName = (x) =>
//   String(
//     pick(
//       x?.class_Name,
//       x?.class_name,
//       x?.class_display_name,
//       x?.className,
//       x?.course_name,
//       '',
//     ),
//   );

// const getBatchId = (b) =>
//   Number(b?.id ?? b?.batch_id ?? b?.ID ?? b?.BatchId ?? 0) || 0;
// const getBatchName = (b) =>
//   String(pick(b?.batch_name, b?.BatchName, b?.name, b?.Name, ''));
// const getBatchCode = (b) =>
//   String(pick(b?.batch_code, b?.BatchCode, b?.code, b?.Code, ''));

// // BatchExamMaster id (master)
// const getBatchExamId = (x) =>
//   Number(
//     x?.batch_exam_id ??
//       x?.Batch_Exam_ID ??
//       x?.BatchExamId ??
//       x?.batchExamId ??
//       x?.id ??
//       x?.ID ??
//       0,
//   ) || 0;

// // optional pattern_id if exists
// const getPatternId = (p) =>
//   Number(p?.pattern_id ?? p?.PatternId ?? p?.patternId ?? 0) || 0;

// // label should show pattern_name (backend will send after join)
// const getPatternName = (p) =>
//   String(
//     pick(
//       p?.pattern_name, // ✅ from backend join (term_name)
//       p?.PatternName,
//       p?.patternName,
//       p?.term_name,
//       p?.TermName,
//       p?.termName,
//       p?.name,
//       '',
//     ),
//   );

// // Enrollment student fields
// const pickEnrollStudentId = (x) =>
//   Number(x?.student_id ?? x?.StudentId ?? x?.studentId ?? 0) || 0;

// const pickEnrollStudentName = (x) =>
//   String(
//     pick(x?.student_name, x?.StudentName, x?.name, x?.Name, x?.full_name, ''),
//   );

// const pickEnrollRoll = (x) =>
//   String(
//     pick(
//       x?.roll_no,
//       x?.RollNo,
//       x?.roll,
//       x?.Roll,
//       x?.enrollment_number,
//       x?.EnrollmentNumber,
//       x?.admit_no,
//       x?.AdmitNo,
//       '',
//     ),
//   );

// // react-select styles
// const selectStyles = {
//   control: (base) => ({ ...base, minHeight: 36, height: 36, fontSize: 14 }),
//   valueContainer: (base) => ({ ...base, height: 36, padding: '0 8px' }),
//   input: (base) => ({ ...base, margin: 0, padding: 0 }),
//   indicatorsContainer: (base) => ({ ...base, height: 36 }),
// };

// const AddEditStudentExamResult = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useSelector((s) => s.authState);
//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);

//   const [form, setForm] = useState({
//     id: 0,
//     vendor_id: '',
//     branch_id: '',

//     class_id: '',
//     class_name: '',

//     batch_id: '',
//     batch_name: '',
//     batch_code: '',

//     batch_exam_id: '', // value = BatchExamMaster.id
//     pattern_id: '', // optional
//   });

//   const [courseOptions, setCourseOptions] = useState([]);
//   const [batchOptions, setBatchOptions] = useState([]);
//   const [patternOptions, setPatternOptions] = useState([]);

//   const [courseLoading, setCourseLoading] = useState(false);
//   const [batchLoading, setBatchLoading] = useState(false);
//   const [patternLoading, setPatternLoading] = useState(false);

//   // Students rows (from Enrollment)
//   const [rows, setRows] = useState([]);

//   // Prefill (optional)
//   useEffect(() => {
//     const st = location.state;
//     if (!st) return;

//     setForm((prev) => ({
//       ...prev,
//       ...st,
//       vendor_id: st.vendor_id ?? prev.vendor_id,
//       branch_id: st.branch_id ?? prev.branch_id,
//       class_id: String(st.class_id ?? st.classId ?? prev.class_id ?? ''),
//       class_name: st.class_name ?? st.className ?? prev.class_name,
//       batch_id: String(st.batch_id ?? st.batchId ?? prev.batch_id ?? ''),
//       batch_name: st.batch_name ?? st.batchName ?? prev.batch_name,
//       batch_code: st.batch_code ?? st.batchCode ?? prev.batch_code,
//       batch_exam_id: String(
//         st.batch_exam_id ?? st.batchExamId ?? prev.batch_exam_id ?? '',
//       ),
//       pattern_id: String(
//         st.pattern_id ?? st.patternId ?? prev.pattern_id ?? '',
//       ),
//     }));
//   }, [location.state]);

//   // ---------------- Courses ----------------
//   const fetchCourses = async (searchText = '') => {
//     try {
//       const vendorId = form.vendor_id || '';
//       const branchId = form.branch_id || '';
//       // if (!vendorId || !branchId) return setCourseOptions([]);

//       setCourseLoading(true);
//       const res = await apiService.get(
//         `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
//           searchText || '',
//         )}`,
//       );

//       if (res?.status === true) {
//         const list = normalizeArray(res?.data) || normalizeArray(res) || [];
//         setCourseOptions(
//           (list || [])
//             .map((x) => ({
//               value: getClassId(x),
//               label: getClassName(x) || `Class-${getClassId(x)}`,
//             }))
//             .filter((o) => o.value > 0),
//         );
//       } else setCourseOptions([]);
//     } catch (e) {
//       console.log(e);
//       setCourseOptions([]);
//     } finally {
//       setCourseLoading(false);
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: form.vendor_id,
//       branchId: form.branch_id,
//     });
//     if (!canLoad) return;
//     fetchCourses('');
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [form.vendor_id, form.branch_id]);

//   // ---------------- Batches ----------------
//   const fetchBatches = async (classId, searchText = '') => {
//     try {
//       const vendorId = form.vendor_id || '';
//       const branchId = form.branch_id || '';
//       // if (!vendorId || !branchId || !classId) return setBatchOptions([]);

//       // setBatchLoading(true);
//       const res = await apiService.get(
//         `api/BatchMaster/GetAllBatch?vendorId=${vendorId}&branchId=${branchId}&classId=${classId}&search=${encodeURIComponent(
//           searchText || '',
//         )}`,
//       );

//       if (res?.status === true) {
//         const list = normalizeArray(res?.data) || normalizeArray(res) || [];
//         setBatchOptions(
//           (list || [])
//             .map((b) => {
//               const id = getBatchId(b);
//               const name = getBatchName(b);
//               const code = getBatchCode(b);
//               return {
//                 value: id,
//                 label: code ? `${code} - ${name}` : name || `Batch-${id}`,
//                 meta: { name, code },
//               };
//             })
//             .filter((o) => o.value > 0),
//         );
//       } else setBatchOptions([]);
//     } catch (e) {
//       console.log(e);
//       setBatchOptions([]);
//     } finally {
//       setBatchLoading(false);
//     }
//   };

//   // ---------------- Patterns (BatchExamMaster) ----------------
//   const fetchPatterns = async (batchId, searchText = '') => {
//     try {
//       const vendorId = form.vendor_id || '';
//       const branchId = form.branch_id || '';

//       // if (!vendorId || !branchId || !batchId) {
//       //   setPatternOptions([]);
//       //   return;
//       // }

//       // setPatternLoading(true);

//       const res = await apiService.get(
//         `api/BatchExamMaster/GetAllBatchExamMaster?vendorId=${vendorId}&branchId=${branchId}&batchId=${batchId}&search=${encodeURIComponent(searchText || '')}`,
//       );

//       // ✅ handle both:
//       // 1) apiService returns response.data directly
//       // 2) apiService returns axios response { data: {...} }
//       const api = res?.data?.status !== undefined ? res.data : res;

//       const isOk = api?.status === true;
//       if (!isOk) {
//         setPatternOptions([]);
//         toast.error(api?.Message || api?.message || 'Failed to load patterns');
//         return;
//       }

//       // ✅ backend list:
//       // ModelBatchExamResp { status, Message, Data }
//       const list =
//         api?.Data || // Pascal case
//         api?.data || // if someone used data
//         api?.data?.Data || // nested
//         [];

//       const options = (Array.isArray(list) ? list : []).map((x) => ({
//         value: Number(x?.id || 0), // Batch_Exam_Master.id
//         label: (x?.pattern_name || '').trim() || `Exam-${x?.id}`,
//         meta: {
//           batch_exam_id: Number(x?.id || 0),
//           pattern_id: Number(x?.pattern_id || 0),
//         },
//       }));

//       setPatternOptions(options.filter((o) => o.value > 0));
//     } catch (err) {
//       console.error(err);
//       setPatternOptions([]);
//       toast.error('Something went wrong while loading patterns');
//     } finally {
//       setPatternLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!form.class_id) {
//       setBatchOptions([]);
//       setPatternOptions([]);
//       setRows([]);
//       setIsLoaded(false);
//       return;
//     }
//     fetchBatches(form.class_id, '');
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [form.class_id, form.vendor_id, form.branch_id]);

//   // ---------------- Enrollment: batch-wise students ----------------
//   const fetchEnrollmentStudents = async () => {
//     try {
//       const vendorId = form.vendor_id || '';
//       const branchId = form.branch_id || '';
//       const classId = form.class_id || '';
//       const batchId = form.batch_id || '';

//       // if (!vendorId || !branchId || !classId || !batchId) return [];

//       // ✅ REQUIRED: backend should accept batchId in GetAllEnrollment
//       const url =
//         `api/Enrollment/GetAllEnrollment?vendorId=${vendorId}` +
//         `&branchId=${branchId}` +
//         `&classId=${classId}` +
//         `&batchId=${batchId}` +
//         `&sessionYear=` +
//         `&search=`;

//       const res = await apiService.get(url);
//       if (res?.status !== true) return [];

//       const list = normalizeArray(res?.data) || normalizeArray(res) || [];

//       // unique students
//       const uniq = [];
//       const seen = new Set();

//       for (const x of list) {
//         const sid = pickEnrollStudentId(x);
//         if (!sid) continue;
//         if (seen.has(sid)) continue;
//         seen.add(sid);

//         uniq.push({
//           id: 0, // (if you later fetch existing result id, set here)
//           student_id: sid,
//           roll: pickEnrollRoll(x),
//           student_name: pickEnrollStudentName(x),
//           total_marks: '',
//           obtained_marks: '',
//         });
//       }

//       return uniq;
//     } catch (e) {
//       console.log(e);
//       return [];
//     }
//   };

//   // ---------------- Handlers ----------------
//   const onCourseSelect = (opt) => {
//     const classId = opt?.value ? String(opt.value) : '';
//     setIsLoaded(false);
//     setRows([]);

//     setForm((prev) => ({
//       ...prev,
//       class_id: classId,
//       class_name: opt?.label || '',
//       batch_id: '',
//       batch_name: '',
//       batch_code: '',
//       batch_exam_id: '',
//       pattern_id: '',
//     }));

//     if (classId) fetchBatches(classId, '');
//   };

//   const onBatchSelect = (opt) => {
//     const newBatchId = opt?.value ? String(opt.value) : '';
//     setIsLoaded(false);
//     setRows([]);

//     setForm((prev) => ({
//       ...prev,
//       batch_id: newBatchId,
//       batch_name: opt?.meta?.name || '',
//       batch_code: opt?.meta?.code || '',
//       batch_exam_id: '',
//       pattern_id: '',
//     }));

//     if (newBatchId) fetchPatterns(newBatchId, '');
//     else setPatternOptions([]);
//   };

//   const onPatternSelect = (opt) => {
//     setIsLoaded(false);
//     setRows([]);

//     setForm((prev) => ({
//       ...prev,
//       batch_exam_id: opt?.meta?.batch_exam_id
//         ? String(opt.meta.batch_exam_id)
//         : opt?.value
//           ? String(opt.value)
//           : '',
//       pattern_id: opt?.meta?.pattern_id ? String(opt.meta.pattern_id) : '',
//     }));
//   };

//   // ---------------- Load ----------------
//   const onLoadClick = async () => {
//     try {
//       setErrors({});

//       if (!form.vendor_id || !form.branch_id)
//         return toast.error('Please select Vendor/Branch');
//       if (!form.class_id) return toast.error('Please select Course/Class');
//       if (!form.batch_id) return toast.error('Please select Batch');
//       if (!form.batch_exam_id) return toast.error('Please select Pattern');

//       setLoading(true);
//       setIsLoaded(false);
//       setRows([]);

//       const students = await fetchEnrollmentStudents();

//       if (!students.length) {
//         toast.error('No students found for selected batch.');
//         return;
//       }

//       setRows(students);
//       setIsLoaded(true);
//     } catch (e) {
//       console.log(e);
//       toast.error('Something went wrong while loading students.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------------- row update ----------------
//   const updateRow = (studentId, patch) => {
//     setRows((prev) =>
//       prev.map((r) =>
//         Number(r.student_id) === Number(studentId) ? { ...r, ...patch } : r,
//       ),
//     );
//   };

//   // ---------------- Save ----------------
//   const validateBeforeSave = () => {
//     if (!isLoaded || !rows.length)
//       return (toast.error('Please click Load first.'), false);

//     const bad = rows.find(
//       (r) =>
//         String(r.obtained_marks).trim() === '' ||
//         Number.isNaN(Number(r.obtained_marks)) ||
//         (String(r.total_marks).trim() !== '' &&
//           Number.isNaN(Number(r.total_marks))),
//     );
//     if (bad)
//       return (
//         toast.error('Please enter numeric marks. Obtained Marks is required.'),
//         false
//       );

//     return true;
//   };

//   const SaveAll = async () => {
//     if (!validateBeforeSave()) return;

//     try {
//       setLoading(true);

//       let ok = 0;
//       let fail = 0;

//       for (const r of rows) {
//         const payload = {
//           id: r.id ? Number(r.id) : null,

//           vendor_id: Number(form.vendor_id),
//           branch_id: Number(form.branch_id),

//           batch_exam_id: Number(form.batch_exam_id),
//           class_id: Number(form.class_id),
//           batch_id: Number(form.batch_id),
//           pattern_id: form.pattern_id ? Number(form.pattern_id) : null,

//           student_id: Number(r.student_id),

//           total_marks:
//             String(r.total_marks).trim() === '' ? null : Number(r.total_marks),
//           obtained_marks:
//             String(r.obtained_marks).trim() === ''
//               ? null
//               : Number(r.obtained_marks),
//         };

//         try {
//           let res;
//           if (Number(r.id || 0) > 0) {
//             res = await apiService.put(
//               `api/ExamMaster/UpdateStudentExamResultSummary?id=${Number(
//                 r.id,
//               )}`,
//               payload,
//             );
//           } else {
//             res = await apiService.post(
//               `api/ExamMaster/AddStudentExamResultSummary`,
//               payload,
//             );
//           }

//           if (res?.status === true) ok++;
//           else fail++;
//         } catch (e) {
//           console.log(e);
//           fail++;
//         }
//       }

//       if (fail === 0) toast.success(`Saved successfully (${ok})`);
//       else toast.warning(`Saved: ${ok}, Failed: ${fail}`);
//     } catch (e) {
//       console.log(e);
//       toast.error('Something went wrong while saving.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------------- Selected options ----------------
//   const selectedCourseOpt = useMemo(
//     () =>
//       courseOptions.find((o) => Number(o.value) === Number(form.class_id)) ||
//       null,
//     [courseOptions, form.class_id],
//   );
//   const selectedBatchOpt = useMemo(
//     () =>
//       batchOptions.find((o) => Number(o.value) === Number(form.batch_id)) ||
//       null,
//     [batchOptions, form.batch_id],
//   );
//   const selectedPatternOpt = useMemo(
//     () =>
//       patternOptions.find(
//         (o) => Number(o.value) === Number(form.batch_exam_id),
//       ) || null,
//     [patternOptions, form.batch_exam_id],
//   );

//   const canLoad =
//     !!form.vendor_id &&
//     !!form.branch_id &&
//     !!form.class_id &&
//     !!form.batch_id &&
//     !!form.batch_exam_id;

//   return (
//     <>
//       <VendorBranchSelector
//         user={user}
//         selectionData={form}
//         setSelectionData={setForm}
//         errorMessage={errors}
//         accessButton={true}
//       />

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
//           <span>Student Exam Result (Enrollment → Batch-wise)</span>

//           <div className='d-flex gap-2'>
//             <Button color='primary' onClick={SaveAll} disabled={loading}>
//               {loading ? 'Saving...' : 'Save'}
//             </Button>
//             <Button
//               color='warning'
//               onClick={() => navigate(-1)}
//               disabled={loading}
//             >
//               <i className='bi bi-arrow-left' />
//             </Button>
//           </div>
//         </CardTitle>

//         <CardBody>
//           <Row>
//             <FormGroup className='col-sm-6'>
//               <Label>Course / Class</Label>
//               <Select
//                 styles={selectStyles}
//                 options={courseOptions}
//                 value={selectedCourseOpt}
//                 isLoading={courseLoading}
//                 isSearchable
//                 isClearable
//                 placeholder='Search courses...'
//                 onChange={onCourseSelect}
//                 onInputChange={(input, meta) => {
//                   if (meta.action === 'input-change') fetchCourses(input);
//                 }}
//               />
//               {errors.class_id ? (
//                 <FormText color='danger'>{errors.class_id}</FormText>
//               ) : null}
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Batch Name</Label>
//               <Select
//                 styles={selectStyles}
//                 options={batchOptions}
//                 value={selectedBatchOpt}
//                 isLoading={batchLoading}
//                 isSearchable
//                 isClearable
//                 placeholder='Search batches...'
//                 isDisabled={!form.class_id}
//                 onChange={onBatchSelect}
//                 onInputChange={(input, meta) => {
//                   if (meta.action === 'input-change')
//                     fetchBatches(form.class_id, input);
//                 }}
//               />
//               {errors.batch_id ? (
//                 <FormText color='danger'>{errors.batch_id}</FormText>
//               ) : null}
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Pattern (from Batch Exam Master)</Label>
//               <Select
//                 styles={selectStyles}
//                 options={patternOptions}
//                 value={selectedPatternOpt}
//                 isLoading={patternLoading}
//                 isSearchable
//                 isClearable
//                 placeholder='Search pattern...'
//                 isDisabled={!form.batch_id}
//                 onChange={onPatternSelect}
//                 onInputChange={(input, meta) => {
//                   if (meta.action === 'input-change')
//                     fetchPatterns(form.batch_id, input);
//                 }}
//               />
//               {errors.pattern_id ? (
//                 <FormText color='danger'>{errors.pattern_id}</FormText>
//               ) : null}
//             </FormGroup>

//             <FormGroup className='col-sm-2 d-flex align-items-end'>
//               <Button
//                 color='info'
//                 size='sm'
//                 style={{ width: '100%' }}
//                 onClick={onLoadClick}
//                 disabled={!canLoad || loading}
//               >
//                 {loading ? '...' : 'Load'}
//               </Button>
//             </FormGroup>
//           </Row>

//           <hr className='my-4' />

//           {!isLoaded ? (
//             <div className='text-muted'>
//               Select Course/Batch/Pattern and click <b>Load</b>.
//             </div>
//           ) : (
//             <>
//               <div className='text-muted mb-2'>
//                 Total Marks optional , <b>Obtained Marks required</b> .
//               </div>

//               <Table bordered responsive size='sm'>
//                 <thead>
//                   <tr>
//                     <th style={{ width: 60 }}>#</th>
//                     <th style={{ width: 170 }}>Roll/Enroll</th>
//                     <th>Student Name</th>
//                     <th style={{ width: 160 }}>Total Marks</th>
//                     <th style={{ width: 160 }}>Obtained Marks</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rows.map((r, idx) => (
//                     <tr key={`stu_${r.student_id}`}>
//                       <td>{idx + 1}</td>
//                       <td>
//                         <Input type='text' value={r.roll || ''} readOnly />
//                       </td>
//                       <td>
//                         <Input
//                           type='text'
//                           value={r.student_name || ''}
//                           readOnly
//                         />
//                       </td>
//                       <td>
//                         <Input
//                           type='number'
//                           value={r.total_marks}
//                           onChange={(e) =>
//                             updateRow(r.student_id, {
//                               total_marks: e.target.value,
//                             })
//                           }
//                           placeholder='(optional)'
//                         />
//                       </td>
//                       <td>
//                         <Input
//                           type='number'
//                           value={r.obtained_marks}
//                           onChange={(e) =>
//                             updateRow(r.student_id, {
//                               obtained_marks: e.target.value,
//                             })
//                           }
//                           placeholder='Enter obtained'
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </>
//           )}
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default AddEditStudentExamResult;
//new 6 april
// AddEditStudentExamResult.jsx

import React, { useEffect, useMemo, useState } from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Button,
  Row,
  FormGroup,
  Label,
  Input,
  Table,
  FormText,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';

import VendorBranchSelector from '../../components/VendorBranchSelector';
import { apiService } from '../../constants/ApiService';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';

// ---------- helpers ----------
const pick = (...vals) =>
  vals.find((v) => v !== undefined && v !== null && v !== '');

const toSafeString = (...vals) => {
  const val = pick(...vals);
  return val == null ? '' : String(val);
};

const getCaseInsensitive = (obj, key) => {
  if (!obj || typeof obj !== 'object') return undefined;
  const foundKey = Object.keys(obj).find(
    (k) => k.toLowerCase() === String(key).toLowerCase(),
  );
  return foundKey ? obj[foundKey] : undefined;
};

const normalizeArray = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;

  const directKeys = [
    'Data',
    'data',
    'List',
    'list',
    'Result',
    'result',
    'Items',
    'items',
    'singleRecord',
    'SingleRecord',
  ];

  for (const k of directKeys) {
    const v = getCaseInsensitive(payload, k);
    if (Array.isArray(v)) return v;
  }

  const nested1 = getCaseInsensitive(payload, 'data');
  const nested2 = getCaseInsensitive(payload, 'Data');

  if (nested1 && typeof nested1 === 'object') {
    const a = normalizeArray(nested1);
    if (a.length) return a;
  }
  if (nested2 && typeof nested2 === 'object') {
    const a = normalizeArray(nested2);
    if (a.length) return a;
  }

  return [];
};

// pickers
const getClassId = (x) =>
  Number(x?.id ?? x?.class_id ?? x?.ClassId ?? x?.course_id ?? 0) || 0;

const getClassName = (x) =>
  String(
    pick(
      x?.class_Name,
      x?.class_name,
      x?.class_display_name,
      x?.className,
      x?.course_name,
      x?.courseName,
      '',
    ),
  );

const getBatchId = (b) =>
  Number(b?.id ?? b?.batch_id ?? b?.ID ?? b?.BatchId ?? 0) || 0;

const getBatchName = (b) =>
  String(pick(b?.batch_name, b?.BatchName, b?.name, b?.Name, ''));

const getBatchCode = (b) =>
  String(pick(b?.batch_code, b?.BatchCode, b?.code, b?.Code, ''));

// BatchExamMaster id (master)
const getBatchExamId = (x) =>
  Number(
    x?.batch_exam_id ??
      x?.Batch_Exam_ID ??
      x?.BatchExamId ??
      x?.batchExamId ??
      x?.id ??
      x?.ID ??
      0,
  ) || 0;

// optional pattern_id if exists
const getPatternId = (p) =>
  Number(p?.pattern_id ?? p?.PatternId ?? p?.patternId ?? 0) || 0;

// label should show pattern_name
const getPatternName = (p) =>
  String(
    pick(
      p?.pattern_name,
      p?.PatternName,
      p?.patternName,
      p?.term_name,
      p?.TermName,
      p?.termName,
      p?.name,
      '',
    ),
  );

// Enrollment student fields
const pickEnrollStudentId = (x) =>
  Number(
    x?.student_id ?? x?.StudentId ?? x?.studentId ?? x?.id ?? x?.ID ?? 0,
  ) || 0;

const pickEnrollStudentName = (x) =>
  String(
    pick(
      x?.student_name,
      x?.StudentName,
      x?.studentName,
      x?.name,
      x?.Name,
      x?.full_name,
      x?.fullName,
      '',
    ),
  );

const pickEnrollRoll = (x) =>
  String(
    pick(
      x?.roll_no,
      x?.RollNo,
      x?.roll,
      x?.Roll,
      x?.enrollment_number,
      x?.EnrollmentNumber,
      x?.admit_no,
      x?.AdmitNo,
      '',
    ),
  );

// react-select styles
const selectStyles = {
  control: (base) => ({ ...base, minHeight: 36, height: 36, fontSize: 14 }),
  valueContainer: (base) => ({ ...base, height: 36, padding: '0 8px' }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: (base) => ({ ...base, height: 36 }),
};

const AddEditStudentExamResult = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const authState = useSelector((s) => s?.authState || {});
  const user = authState?.user || authState?.User || {};

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user || {});

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const [form, setForm] = useState({
    id: 0,
    vendor_id: toSafeString(
      user?.vendor_id,
      user?.vendorId,
      user?.VendorID,
      user?.vendorID,
      '',
    ),
    branch_id: toSafeString(
      user?.branch_id,
      user?.branchId,
      user?.BranchID,
      user?.branchID,
      '',
    ),

    class_id: '',
    class_name: '',

    batch_id: '',
    batch_name: '',
    batch_code: '',

    batch_exam_id: '',
    pattern_id: '',
  });

  const safeForm = form && typeof form === 'object' ? form : {};

  const handleSelectionData = (updater) => {
    setForm((prev) => {
      const prevSafe = prev && typeof prev === 'object' ? prev : {};
      const next = typeof updater === 'function' ? updater(prevSafe) : updater;
      const nextSafe = next && typeof next === 'object' ? next : {};

      return {
        ...prevSafe,
        ...nextSafe,
      };
    });
  };

  const [courseOptions, setCourseOptions] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);
  const [patternOptions, setPatternOptions] = useState([]);

  const [courseLoading, setCourseLoading] = useState(false);
  const [batchLoading, setBatchLoading] = useState(false);
  const [patternLoading, setPatternLoading] = useState(false);

  // Students rows (from Enrollment)
  const [rows, setRows] = useState([]);

  // Prefill (optional)
  useEffect(() => {
    const st = location.state;
    if (!st) return;

    setForm((prev) => ({
      ...prev,
      ...st,
      vendor_id: toSafeString(st.vendor_id, st.vendorId, prev.vendor_id),
      branch_id: toSafeString(st.branch_id, st.branchId, prev.branch_id),
      class_id: toSafeString(st.class_id, st.classId, prev.class_id),
      class_name: toSafeString(st.class_name, st.className, prev.class_name),
      batch_id: toSafeString(st.batch_id, st.batchId, prev.batch_id),
      batch_name: toSafeString(st.batch_name, st.batchName, prev.batch_name),
      batch_code: toSafeString(st.batch_code, st.batchCode, prev.batch_code),
      batch_exam_id: toSafeString(
        st.batch_exam_id,
        st.batchExamId,
        prev.batch_exam_id,
      ),
      pattern_id: toSafeString(st.pattern_id, st.patternId, prev.pattern_id),
    }));
  }, [location.state]);

  // ---------------- Courses ----------------
  const fetchCourses = async (searchText = '') => {
    try {
      const vendorId = safeForm.vendor_id || '';
      const branchId = safeForm.branch_id || '';

      if (!vendorId || !branchId) {
        setCourseOptions([]);
        return;
      }

      setCourseLoading(true);

      const res = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res?.status === true) {
        const list = normalizeArray(res?.data) || normalizeArray(res) || [];
        setCourseOptions(
          (list || [])
            .map((x) => ({
              value: getClassId(x),
              label: getClassName(x) || `Class-${getClassId(x)}`,
            }))
            .filter((o) => o.value > 0),
        );
      } else {
        setCourseOptions([]);
      }
    } catch (e) {
      console.log(e);
      setCourseOptions([]);
    } finally {
      setCourseLoading(false);
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: safeForm.vendor_id,
      branchId: safeForm.branch_id,
    });

    if (!canLoad) return;
    fetchCourses('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [safeForm.vendor_id, safeForm.branch_id]);

  // ---------------- Batches ----------------
  const fetchBatches = async (classId, searchText = '') => {
    try {
      const vendorId = safeForm.vendor_id || '';
      const branchId = safeForm.branch_id || '';

      if (!vendorId || !branchId || !classId) {
        setBatchOptions([]);
        return;
      }

      setBatchLoading(true);

      const res = await apiService.get(
        `api/BatchMaster/GetAllBatch?vendorId=${vendorId}&branchId=${branchId}&classId=${classId}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res?.status === true) {
        const list = normalizeArray(res?.data) || normalizeArray(res) || [];
        setBatchOptions(
          (list || [])
            .map((b) => {
              const id = getBatchId(b);
              const name = getBatchName(b);
              const code = getBatchCode(b);

              return {
                value: id,
                label: code ? `${code} - ${name}` : name || `Batch-${id}`,
                meta: { name, code },
              };
            })
            .filter((o) => o.value > 0),
        );
      } else {
        setBatchOptions([]);
      }
    } catch (e) {
      console.log(e);
      setBatchOptions([]);
    } finally {
      setBatchLoading(false);
    }
  };

  // ---------------- Patterns (BatchExamMaster) ----------------
  const fetchPatterns = async (batchId, searchText = '') => {
    try {
      const vendorId = safeForm.vendor_id || '';
      const branchId = safeForm.branch_id || '';

      if (!vendorId || !branchId || !batchId) {
        setPatternOptions([]);
        return;
      }

      setPatternLoading(true);

      const res = await apiService.get(
        `api/BatchExamMaster/GetAllBatchExamMaster?vendorId=${vendorId}&branchId=${branchId}&batchId=${batchId}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      const api = res?.data?.status !== undefined ? res.data : res;
      const isOk = api?.status === true;

      if (!isOk) {
        setPatternOptions([]);
        toast.error(api?.Message || api?.message || 'Failed to load patterns');
        return;
      }

      const list = api?.Data || api?.data || api?.data?.Data || [];

      const options = (Array.isArray(list) ? list : [])
        .map((x) => ({
          value: getBatchExamId(x),
          label: getPatternName(x) || `Exam-${getBatchExamId(x)}`,
          meta: {
            batch_exam_id: getBatchExamId(x),
            pattern_id: getPatternId(x),
          },
        }))
        .filter((o) => o.value > 0);

      setPatternOptions(options);
    } catch (err) {
      console.error(err);
      setPatternOptions([]);
      toast.error('Something went wrong while loading patterns');
    } finally {
      setPatternLoading(false);
    }
  };

  useEffect(() => {
    if (!safeForm.class_id) {
      setBatchOptions([]);
      setPatternOptions([]);
      setRows([]);
      setIsLoaded(false);
      return;
    }

    fetchBatches(safeForm.class_id, '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [safeForm.class_id, safeForm.vendor_id, safeForm.branch_id]);

  // ---------------- Enrollment: batch-wise students ----------------
  const fetchEnrollmentStudents = async () => {
    try {
      const vendorId = safeForm.vendor_id || '';
      const branchId = safeForm.branch_id || '';
      const classId = safeForm.class_id || '';
      const batchId = safeForm.batch_id || '';

      if (!vendorId || !branchId || !classId || !batchId) return [];

      const url =
        `api/Enrollment/GetAllEnrollment?vendorId=${vendorId}` +
        `&branchId=${branchId}` +
        `&classId=${classId}` +
        `&batchId=${batchId}` +
        `&sessionYear=` +
        `&search=`;

      const res = await apiService.get(url);
      if (res?.status !== true) return [];

      const list = normalizeArray(res?.data) || normalizeArray(res) || [];

      const uniq = [];
      const seen = new Set();

      for (const x of list) {
        const sid = pickEnrollStudentId(x);
        if (!sid) continue;
        if (seen.has(sid)) continue;
        seen.add(sid);

        uniq.push({
          id: 0,
          student_id: sid,
          roll: pickEnrollRoll(x),
          student_name: pickEnrollStudentName(x),
          total_marks: '',
          obtained_marks: '',
        });
      }

      return uniq;
    } catch (e) {
      console.log(e);
      return [];
    }
  };

  // ---------------- Handlers ----------------
  const onCourseSelect = (opt) => {
    const classId = opt?.value ? String(opt.value) : '';

    setIsLoaded(false);
    setRows([]);

    setForm((prev) => ({
      ...prev,
      class_id: classId,
      class_name: opt?.label || '',
      batch_id: '',
      batch_name: '',
      batch_code: '',
      batch_exam_id: '',
      pattern_id: '',
    }));

    if (classId) fetchBatches(classId, '');
  };

  const onBatchSelect = (opt) => {
    const newBatchId = opt?.value ? String(opt.value) : '';

    setIsLoaded(false);
    setRows([]);

    setForm((prev) => ({
      ...prev,
      batch_id: newBatchId,
      batch_name: opt?.meta?.name || '',
      batch_code: opt?.meta?.code || '',
      batch_exam_id: '',
      pattern_id: '',
    }));

    if (newBatchId) {
      fetchPatterns(newBatchId, '');
    } else {
      setPatternOptions([]);
    }
  };

  const onPatternSelect = (opt) => {
    setIsLoaded(false);
    setRows([]);

    setForm((prev) => ({
      ...prev,
      batch_exam_id: opt?.meta?.batch_exam_id
        ? String(opt.meta.batch_exam_id)
        : opt?.value
          ? String(opt.value)
          : '',
      pattern_id: opt?.meta?.pattern_id ? String(opt.meta.pattern_id) : '',
    }));
  };

  // ---------------- Load ----------------
  const onLoadClick = async () => {
    try {
      setErrors({});

      if (!safeForm.vendor_id || !safeForm.branch_id) {
        toast.error('Please select Vendor/Branch');
        return;
      }
      if (!safeForm.class_id) {
        toast.error('Please select Course/Class');
        return;
      }
      if (!safeForm.batch_id) {
        toast.error('Please select Batch');
        return;
      }
      if (!safeForm.batch_exam_id) {
        toast.error('Please select Pattern');
        return;
      }

      setLoading(true);
      setIsLoaded(false);
      setRows([]);

      const students = await fetchEnrollmentStudents();

      if (!students.length) {
        toast.error('No students found for selected batch.');
        return;
      }

      setRows(students);
      setIsLoaded(true);
    } catch (e) {
      console.log(e);
      toast.error('Something went wrong while loading students.');
    } finally {
      setLoading(false);
    }
  };

  // ---------------- row update ----------------
  const updateRow = (studentId, patch) => {
    setRows((prev) =>
      prev.map((r) =>
        Number(r.student_id) === Number(studentId) ? { ...r, ...patch } : r,
      ),
    );
  };

  // ---------------- Save ----------------
  const validateBeforeSave = () => {
    if (!isLoaded || !rows.length) {
      toast.error('Please click Load first.');
      return false;
    }

    const bad = rows.find(
      (r) =>
        String(r.obtained_marks).trim() === '' ||
        Number.isNaN(Number(r.obtained_marks)) ||
        (String(r.total_marks).trim() !== '' &&
          Number.isNaN(Number(r.total_marks))),
    );

    if (bad) {
      toast.error('Please enter numeric marks. Obtained Marks is required.');
      return false;
    }

    return true;
  };

  const SaveAll = async () => {
    if (!validateBeforeSave()) return;

    try {
      setLoading(true);

      let ok = 0;
      let fail = 0;

      for (const r of rows) {
        const payload = {
          id: r.id ? Number(r.id) : null,

          vendor_id: Number(safeForm.vendor_id),
          branch_id: Number(safeForm.branch_id),

          batch_exam_id: Number(safeForm.batch_exam_id),
          class_id: Number(safeForm.class_id),
          batch_id: Number(safeForm.batch_id),
          pattern_id: safeForm.pattern_id ? Number(safeForm.pattern_id) : null,

          student_id: Number(r.student_id),

          total_marks:
            String(r.total_marks).trim() === '' ? null : Number(r.total_marks),
          obtained_marks:
            String(r.obtained_marks).trim() === ''
              ? null
              : Number(r.obtained_marks),
        };

        try {
          let res;

          if (Number(r.id || 0) > 0) {
            res = await apiService.put(
              `api/ExamMaster/UpdateStudentExamResultSummary?id=${Number(r.id)}`,
              payload,
            );
          } else {
            res = await apiService.post(
              'api/ExamMaster/AddStudentExamResultSummary',
              payload,
            );
          }

          if (res?.status === true) ok++;
          else fail++;
        } catch (e) {
          console.log(e);
          fail++;
        }
      }

      if (fail === 0) toast.success(`Saved successfully (${ok})`);
      else toast.warning(`Saved: ${ok}, Failed: ${fail}`);
    } catch (e) {
      console.log(e);
      toast.error('Something went wrong while saving.');
    } finally {
      setLoading(false);
    }
  };

  // ---------------- Selected options ----------------
  const selectedCourseOpt = useMemo(
    () =>
      courseOptions.find(
        (o) => Number(o.value) === Number(safeForm.class_id),
      ) || null,
    [courseOptions, safeForm.class_id],
  );

  const selectedBatchOpt = useMemo(
    () =>
      batchOptions.find((o) => Number(o.value) === Number(safeForm.batch_id)) ||
      null,
    [batchOptions, safeForm.batch_id],
  );

  const selectedPatternOpt = useMemo(
    () =>
      patternOptions.find(
        (o) => Number(o.value) === Number(safeForm.batch_exam_id),
      ) || null,
    [patternOptions, safeForm.batch_exam_id],
  );

  const missingFields = [];
  if (!safeForm.vendor_id) missingFields.push('Vendor');
  if (!safeForm.branch_id) missingFields.push('Branch');
  if (!safeForm.class_id) missingFields.push('Course');
  if (!safeForm.batch_id) missingFields.push('Batch');
  if (!safeForm.batch_exam_id) missingFields.push('Pattern');

  const showVendorBranchSelector =
    isSuperAdmin || isAdmin || hasMultiBranch || hasSingleBranch;

  return (
    <>
      {showVendorBranchSelector ? (
        <VendorBranchSelector
          user={user}
          selectionData={safeForm}
          setSelectionData={handleSelectionData}
          errorMessage={errors}
          accessButton={true}
        />
      ) : null}

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Student Exam Result (Enrollment → Batch-wise)</span>

          <div className='d-flex gap-2'>
            <Button color='primary' onClick={SaveAll} disabled={loading}>
              {loading ? 'Saving...' : 'Save'}
            </Button>
            <Button
              color='warning'
              onClick={() => navigate(-1)}
              disabled={loading}
            >
              <i className='bi bi-arrow-left' />
            </Button>
          </div>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Course / Class</Label>
              <Select
                styles={selectStyles}
                options={courseOptions}
                value={selectedCourseOpt}
                isLoading={courseLoading}
                isSearchable
                isClearable
                placeholder='Search courses...'
                onChange={onCourseSelect}
                onInputChange={(input, meta) => {
                  if (meta.action === 'input-change') fetchCourses(input);
                }}
              />
              {errors.class_id ? (
                <FormText color='danger'>{errors.class_id}</FormText>
              ) : null}
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Batch Name</Label>
              <Select
                styles={selectStyles}
                options={batchOptions}
                value={selectedBatchOpt}
                isLoading={batchLoading}
                isSearchable
                isClearable
                placeholder='Search batches...'
                isDisabled={!safeForm.class_id}
                onChange={onBatchSelect}
                onInputChange={(input, meta) => {
                  if (meta.action === 'input-change')
                    fetchBatches(safeForm.class_id, input);
                }}
              />
              {errors.batch_id ? (
                <FormText color='danger'>{errors.batch_id}</FormText>
              ) : null}
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Pattern (from Batch Exam Master)</Label>
              <Select
                styles={selectStyles}
                options={patternOptions}
                value={selectedPatternOpt}
                isLoading={patternLoading}
                isSearchable
                isClearable
                placeholder='Search pattern...'
                isDisabled={!safeForm.batch_id}
                onChange={onPatternSelect}
                onInputChange={(input, meta) => {
                  if (meta.action === 'input-change')
                    fetchPatterns(safeForm.batch_id, input);
                }}
              />
              {errors.pattern_id ? (
                <FormText color='danger'>{errors.pattern_id}</FormText>
              ) : null}
            </FormGroup>

            <FormGroup className='col-sm-2 d-flex align-items-end'>
              <div style={{ width: '100%' }}>
                <Button
                  color='info'
                  size='sm'
                  style={{ width: '100%' }}
                  onClick={onLoadClick}
                  disabled={loading}
                >
                  {loading ? '...' : 'Load'}
                </Button>

                {missingFields.length > 0 ? (
                  <div className='text-danger mt-1' style={{ fontSize: 12 }}>
                    Missing: {missingFields.join(', ')}
                  </div>
                ) : null}
              </div>
            </FormGroup>
          </Row>

          <hr className='my-4' />

          {!isLoaded ? (
            <div className='text-muted'>
              Select Course/Batch/Pattern and click <b>Load</b>.
            </div>
          ) : (
            <>
              <div className='text-muted mb-2'>
                Total Marks optional, <b>Obtained Marks required</b>.
              </div>

              <Table bordered responsive size='sm'>
                <thead>
                  <tr>
                    <th style={{ width: 60 }}>#</th>
                    <th style={{ width: 170 }}>Roll/Enroll</th>
                    <th>Student Name</th>
                    <th style={{ width: 160 }}>Total Marks</th>
                    <th style={{ width: 160 }}>Obtained Marks</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, idx) => (
                    <tr key={`stu_${r.student_id}`}>
                      <td>{idx + 1}</td>
                      <td>
                        <Input type='text' value={r.roll || ''} readOnly />
                      </td>
                      <td>
                        <Input
                          type='text'
                          value={r.student_name || ''}
                          readOnly
                        />
                      </td>
                      <td>
                        <Input
                          type='number'
                          value={r.total_marks}
                          onChange={(e) =>
                            updateRow(r.student_id, {
                              total_marks: e.target.value,
                            })
                          }
                          placeholder='(optional)'
                        />
                      </td>
                      <td>
                        <Input
                          type='number'
                          value={r.obtained_marks}
                          onChange={(e) =>
                            updateRow(r.student_id, {
                              obtained_marks: e.target.value,
                            })
                          }
                          placeholder='Enter obtained'
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditStudentExamResult;
